import React from 'react';
import classnames from 'classnames';
import IconCard from '@web-common/components/UI/IconCard';
import style from './rowName.module.scss';
import { getIn18Text } from 'api';
import { IMG_TYPES } from '@web-mail/common/constant';
const RowName = ({ id, type, showExtShare = false, name, openFileOrDir, collectAble, starred, thumbnailUrl, collectAction }) => {
    const frontName = name.slice(0, -8);
    const endFront = name.slice(-8);
    const clickRowName = () => {
        openFileOrDir && openFileOrDir();
    };
    const ckStar = (e) => {
        e.stopPropagation();
        id && collectAction && collectAction({ id, collect: !starred, type: type === 'dir' ? 'folder' : 'file' });
    };
    return (React.createElement("div", { className: style.nameColumn, "data-test-id": "disk_table_file_column_btn", onClick: clickRowName, title: name },
        React.createElement("div", { className: style.nameIcon }, type === 'dir' ? (React.createElement(IconCard, { type: "dir" })) : IMG_TYPES.includes(type) && thumbnailUrl ? (React.createElement("img", { style: { maxWidth: '56px', maxHeight: '42px' }, src: thumbnailUrl })) : (React.createElement(IconCard, { type: type, width: "24px", height: "24px" }))),
        React.createElement("div", { className: style.nameText },
            React.createElement("span", { className: style.frontName }, frontName),
            React.createElement("span", null, endFront),
            React.createElement("span", { hidden: !showExtShare, className: style.shareExternal }, getIn18Text('WAIBU')),
            collectAble && (React.createElement("div", { className: classnames([style.starBlk], {
                    [style.starGold + ' starGold']: starred,
                    [style.starGray + ' starGray']: !starred,
                }), onClick: e => ckStar(e), "data-test-id": "disk_table_file_mark_btn" },
                React.createElement(IconCard, { type: starred ? 'starGold' : 'starGray' }))))));
};
export default RowName;
